export const INITIAL_FORM_CUSTOMERS = {
  id: '',
  firstname: '',
  lastname: '',
  fullname: '',
  email: '',
  phone: '',
  addresses: [
    {
      id: '',
      address: '',
      city: '',
      country: '',
      countryName: '',
      countryZone: '',
      countryZoneName: '',
      postalCode: '',
    },
  ],
  orders: [
    {
      id: '',
      state: {
        name: '',
        value: '',
      },
      number: 0,
      label: null,
      flag: '',
      countryName: '',
      fullname: '',
      itemDemandsCount: null,
      itemsCount: null,
      shipping: {
        code: '',
        name: '',
        image: '',
        rates: null,
        description: null,
        price: null,
        priceValue: null,
        notification: null,
        hasOwnTariffs: false,
        isExtended: false,
        cityFrom: null,
        settings: null,
        isApiship: false,
        state: null,
        tariffs: null,
      },
      payment: {
        code: '',
        name: '',
        image: '',
        secrets: null,
        message: '',
        margin: null,
        hasCert: false,
      },
      store: '',
      date: '',
    },
  ],
}
